
import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const QuotePrint = (props) => {
  const {
    cartItems = [],
    userInfo = {},
    purchaseNumber = "",
    cartSubtotal = 0,
    taxAmount = 0,
    // quoteNo = "",
    customerName = "",
  } = props;

  const now = new Date();

  const today =
    String(now.getDate()).padStart(2, "0") +
    String(now.getMonth() + 1).padStart(2, "0") +
    String(now.getFullYear()).slice(-2);

  const quoteNo = `CTL${today}-1`;
  const trimmedCustomerName = customerName
    ?.split(" ")
    .slice(0, 2)
    .join(" ");
  const totalExGst = Number(cartSubtotal || 0);
  const gst = Number(taxAmount || totalExGst * 0.1);
  const totalIncGst = totalExGst + gst;

  const formatMoney = (value) =>
    `$${Number(value || 0).toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 8,
      fontFamily: "Helvetica",
    },

    borderBox: {
      borderWidth: 1,
      borderColor: "#000",
      minHeight: 470,
    },

    topFileName: {
      textAlign: "center",
      fontSize: 7,
      marginBottom: 20,
      fontWeight: "bold",
    },

    header: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#000",
      padding: 10,
      height: 125,
    },

    headerLeft: {
      width: "28%",
      justifyContent: "center",
    },

    customerName: {
      fontSize: 13,
      fontWeight: "bold",
      marginBottom: 18,
    },

    dateText: {
      fontSize: 11,
      fontWeight: "bold",
    },

    headerCenter: {
      width: "44%",
      alignItems: "center",
      justifyContent: "center",
    },

    logo: {
      width: 210,
      height: 65,
      objectFit: "contain",
      marginBottom: 12,
    },

    quotationTitle: {
      fontSize: 15,
      fontWeight: "bold",
      color: "#1f4e79",
    },

    headerRight: {
      width: "28%",
      justifyContent: "center",
      alignItems: "flex-end",
    },

    salesText: {
      fontSize: 8,
      fontWeight: "bold",
      marginBottom: 12,
    },

    email: {
      fontSize: 8,
      color: "#0000EE",
      textDecoration: "underline",
      marginBottom: 22,
    },

    quoteNumber: {
      fontSize: 10,
      fontWeight: "bold",
    },

    table: {
      width: "100%",
      borderBottomWidth: 1,
      borderColor: "#000",
    },

    tableHeader: {
      flexDirection: "row",
      backgroundColor: "#f1f1f1",
      borderBottomWidth: 1,
      borderColor: "#000",
      minHeight: 24,
      alignItems: "center",
    },

    row: {
      flexDirection: "row",
      minHeight: 25,
      borderBottomWidth: 0.5,
      borderColor: "#ccc",
      alignItems: "center",
    },

    colItem: {
      width: "7%",
      textAlign: "center",
      borderRightWidth: 0.5,
      borderColor: "#000",
      padding: 3,
    },

    colQty: {
      width: "6%",
      textAlign: "center",
      borderRightWidth: 0.5,
      borderColor: "#000",
      padding: 3,
    },

    colCatalogue: {
      width: "25%",
      textAlign: "center",
      borderRightWidth: 0.5,
      borderColor: "#000",
      padding: 3,
    },

    colDescription: {
      width: "43%",
      textAlign: "center",
      borderRightWidth: 0.5,
      borderColor: "#000",
      padding: 3,
    },

    colUnit: {
      width: "9.5%",
      textAlign: "center",
      borderRightWidth: 0.5,
      borderColor: "#000",
      padding: 3,
    },

    colTotal: {
      width: "9.5%",
      textAlign: "center",
      padding: 3,
    },

    headerText: {
      fontSize: 7,
      fontWeight: "bold",
    },

    bodyText: {
      fontSize: 7,
    },

    noteBox: {
      padding: 8,
      borderBottomWidth: 1,
      borderColor: "#000",
      textAlign: "center",
    },

    noteText: {
      fontSize: 7,
      fontWeight: "bold",
    },

    bottomSection: {
      flexDirection: "row",
      minHeight: 70,
    },

    termsBox: {
      width: "70%",
      padding: 8,
      borderRightWidth: 1,
      borderColor: "#000",
    },

    termsTitle: {
      fontSize: 7,
      fontWeight: "bold",
      textDecoration: "underline",
      marginBottom: 10,
    },

    termsText: {
      fontSize: 6.5,
      marginBottom: 2,
    },

    totalsBox: {
      width: "30%",
    },

    totalsHeader: {
      flexDirection: "row",
      height: 40,
      borderBottomWidth: 1,
      borderColor: "#000",
    },

    totalCell: {
      width: "33.33%",
      justifyContent: "center",
      alignItems: "center",
      borderRightWidth: 1,
      borderColor: "#000",
      padding: 3,
    },

    totalCellLast: {
      width: "33.33%",
      justifyContent: "center",
      alignItems: "center",
      padding: 3,
    },

    totalsAmount: {
      flexDirection: "row",
      height: 30,
      borderBottomWidth: 1,
      borderColor: "#000",
    },

    amountText: {
      fontSize: 8,
      fontWeight: "bold",
      color: "#1f4e79",
    },

    footer: {
      position: "absolute",
      bottom: 20,
      left: 0,
      right: 0,
      textAlign: "center",
      fontSize: 7,
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.topFileName}>
          {quoteNo || purchaseNumber || "QUOTE"}-{customerName || userInfo.name || ""}
        </Text>

        <View style={styles.borderBox}>
          <View style={styles.header}>
            <View style={styles.headerLeft}>
              <Text style={styles.customerName}>
                {(trimmedCustomerName || userInfo.name || "CUSTOMER").toUpperCase()}
              </Text>
              <Text style={styles.dateText}>DATE : {now.toLocaleDateString("en-AU")}</Text>
            </View>

            <View style={styles.headerCenter}>
              <Image
                style={styles.logo}
                src="https://ctladmin.b-cdn.net/CTL%20Brand%20Images/letterhead1.png"
              />
              <Text style={styles.quotationTitle}>QUOTATION</Text>
            </View>

            <View style={styles.headerRight}>
              <Text style={styles.salesText}>CTL Sales Team</Text>
              <Text style={styles.email}>sales@ctlaus.com</Text>
              <Text style={styles.quoteNumber}>
                QUOTE NO: {quoteNo || purchaseNumber || ""}
              </Text>
            </View>
          </View>

          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <View style={styles.colItem}>
                <Text style={styles.headerText}>ITEM{"\n"}TYPE</Text>
              </View>
              <View style={styles.colQty}>
                <Text style={styles.headerText}>QTY</Text>
              </View>
              <View style={styles.colCatalogue}>
                <Text style={styles.headerText}>CATALOGUE{"\n"}NUMBER</Text>
              </View>
              <View style={styles.colDescription}>
                <Text style={styles.headerText}>ITEM DESCRIPTION</Text>
              </View>
              <View style={styles.colUnit}>
                <Text style={styles.headerText}>UNIT{"\n"}EX GST</Text>
              </View>
              <View style={styles.colTotal}>
                <Text style={styles.headerText}>TOTAL{"\n"}EX GST</Text>
              </View>
            </View>

            {cartItems.map((item, idx) => {
              const product = item.cartProducts?.[0] || {};
              const qty = Number(product.quantity || 0);
              const price = Number(product.price || 0);
              const lineTotal = qty * price;

              return (
                <View style={styles.row} key={idx}>
                  <View style={styles.colItem}>
                    <Text style={styles.bodyText}>{idx + 1}</Text>
                  </View>
                  <View style={styles.colQty}>
                    <Text style={styles.bodyText}>{qty}</Text>
                  </View>
                  <View style={styles.colCatalogue}>
                    <Text style={styles.bodyText}>
                      {product.ctlsku || product.suppliersku || ""}
                    </Text>
                  </View>
                  <View style={styles.colDescription}>
                    <Text style={styles.bodyText}>
                      {(item.name || "").toUpperCase()}
                    </Text>
                  </View>
                  <View style={styles.colUnit}>
                    <Text style={styles.bodyText}>{formatMoney(price)}</Text>
                  </View>
                  <View style={styles.colTotal}>
                    <Text style={styles.bodyText}>{formatMoney(lineTotal)}</Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View style={styles.noteBox}>
            <Text style={styles.noteText}>
              PLEASE ENSURE ALL QUANTITIES, TYPES, DESCRIPTIONS AND MEASUREMENTS ARE CHECKED AS SOME QTYS MAY DIFFER FROM SUPPLIER QUOTE.
            </Text>
            <Text style={styles.noteText}>
              ALL PRODUCTS QUOTED ARE TO SUIT THE INFORMATION PROVIDED.
            </Text>
          </View>

          <View style={styles.bottomSection}>
            <View style={styles.termsBox}>
              <Text style={styles.termsTitle}>
                Terms and Conditions of Quotation.
              </Text>
              <Text style={styles.termsText}>
                1. Any variation in quantities or types may require a requote.
              </Text>
              <Text style={styles.termsText}>
                2. Pricing is valid for 30 days from date of written quotation thereafter will be subject to revalidation.
              </Text>
              <Text style={styles.termsText}>
                3. All Pricing is Subject to GST.
              </Text>
              <Text style={styles.termsText}>
                4. Standard Terms and Conditions apply.
              </Text>
            </View>

            <View style={styles.totalsBox}>
              <View style={styles.totalsHeader}>
                <View style={styles.totalCell}>
                  <Text style={styles.headerText}>TOTAL{"\n"}EX GST</Text>
                </View>
                <View style={styles.totalCell}>
                  <Text style={styles.headerText}>GST{"\n"}PAYABLE</Text>
                </View>
                <View style={styles.totalCellLast}>
                  <Text style={styles.headerText}>TOTAL{"\n"}INC GST</Text>
                </View>
              </View>

              <View style={styles.totalsAmount}>
                <View style={styles.totalCell}>
                  <Text style={styles.amountText}>{formatMoney(totalExGst)}</Text>
                </View>
                <View style={styles.totalCell}>
                  <Text style={styles.amountText}>{formatMoney(gst)}</Text>
                </View>
                <View style={styles.totalCellLast}>
                  <Text style={styles.amountText}>{formatMoney(totalIncGst)}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </Page>
    </Document>
  );
};

export default QuotePrint;